import { SelectOption } from "rivals/components/shared/Form/Select/types";
import type { Conference } from "rivals/shared/interfaces/Conference";
import type { HighschoolGroup } from "rivals/shared/interfaces/HighschoolGroup";
import strings from "./strings";

const getConferencesOptions = (
  conferences: Conference[]
): SelectOption<string>[] => [
  {
    name: strings.allConferences,
    value: ""
  },
  ...conferences.map(({ abbreviation, name }) => ({
    name: name,
    value: abbreviation
  }))
];

const getHighschoolGroupsOptions = (
  highschoolGroups: HighschoolGroup[]
): SelectOption<string>[] => [
  {
    name: strings.allRegions,
    value: ""
  },
  ...highschoolGroups.map(({ title }) => ({
    name: title,
    value: title.toLowerCase()
  }))
];

export { getConferencesOptions, getHighschoolGroupsOptions };
